import { useStoreUser } from '../../../context';
import { overviewService } from '../../../services';
import { OverviewQuery } from '../../../types';
import { showToRoles } from '../../../utils';
import { getCountryCityCoordinates } from '../../../const';
import { useQuery } from '../use-query';

const initialOverviewLastGateCompleted: OverviewQuery['data']['lastGateCompleted'][0] = {
  completedAt: new Date().toISOString(),
  number: 'AAAA1234567',
  status: 'GATED_IN',
};

const initialOverviewLastGateActive: OverviewQuery['data']['lastGateActive'][0] = {
  createdAt: new Date().toISOString(),
  validTo: new Date().toISOString(),
  authorizedLicensePlateNumbers: ['1234567890'],
  driverLicensePlateNumber: '1234567890',
  driverFirstName: 'John',
  driverLastName: 'Doe',
  gateStatus: 'ACTIVE',
  number: 'AAAA1234567',
  status: 'GATED_IN',
  isLoaded: false,
};

const initialOverview: OverviewQuery['data'] = {
  gateInCompletedCount: [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ],
  gateInCompletedCountOld: [],
  gateOutCompletedCount: [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ],
  gateOutCompletedCountOld: [],
  containerCount: 0,
  containerCountByStatus: {
    gateInCount: 0,
    onHoldCount: 0,
    forSaleCount: 0,
    repairCount: 0,
    gateOutRequestedCount: 0,
  },
  containerCountByType: {
    '20DC': 0,
    '20HC': 0,
    '20RF': 0,
    '40DC': 0,
    '40HC': 0,
    '40RF': 0,
    '40OT': 0,
    '40FR': 0,
    '45HC': 0,
  },
  depotOccupancy: {
    totalCapacity: 0,
    occupied: 0,
    available: 0,
    occupancyByArea: [],
    occupancyByContainerType: {
      '20DC': 0,
      '20HC': 0,
      '20RF': 0,
      '40DC': 0,
      '40HC': 0,
      '40RF': 0,
      '40OT': 0,
      '40FR': 0,
      '45HC': 0,
      empty: 0,
    },
    occupancyTrend: [],
  },
  containerByLocation: [],
  lastGateCompleted: [
    initialOverviewLastGateCompleted,
    initialOverviewLastGateCompleted,
    initialOverviewLastGateCompleted,
    initialOverviewLastGateCompleted,
    initialOverviewLastGateCompleted,
  ],
  operations: {
    gateOutActiveCount: 0,
    gateInExpiredCount: 0,
    gateOutExpiredCount: 0,
    repairCount: 0,
  },
  lastGateActive: [
    initialOverviewLastGateActive,
    initialOverviewLastGateActive,
    initialOverviewLastGateActive,
    initialOverviewLastGateActive,
    initialOverviewLastGateActive,
  ],
  alerts: {
    containerWithoutLocationCount: 0,
    repairClientNotAssignedCount: 0,
    repairClientAssignedCount: 0,
    heldMoreDaysContainersCount: 0,
  },
};

export const useOverviewQuery = (keys: any = {}) => {
  const { user } = useStoreUser();

  return useQuery(
    ['overview', JSON.stringify(keys)],
    async () => {
      if (!showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER', 'VENDOR'], user) && !keys.yardId) {
        return Promise.resolve(initialOverview);
      }

      const data = await overviewService.get({ params: keys }).then((res) => res.data.data);

      if (showToRoles(['VENDOR'], user)) {
        data.containerByLocation = data.containerByLocation.map((item) => ({
          ...item,
          ...getCountryCityCoordinates(item.country, item.city),
        }));
      }

      return data;
    },
    { initialData: null, cacheTime: 0 },
  );
};
